import { cn } from '@/lib/utils';

interface SkeletonShimmerProps {
  className?: string;
}

export function SkeletonShimmer({ className }: SkeletonShimmerProps) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-lg bg-muted",
        "before:absolute before:inset-0",
        "before:translate-x-[-100%]",
        "before:animate-[shimmer_2s_infinite]",
        "before:bg-gradient-to-r",
        "before:from-transparent before:via-white/10 before:to-transparent",
        className
      )}
    />
  );
}

export function CardSkeleton() {
  return (
    <div className="surface-elevated rounded-2xl p-6 space-y-4">
      <div className="flex items-center gap-4">
        <SkeletonShimmer className="h-16 w-16 rounded-lg" />
        <div className="flex-1 space-y-2">
          <SkeletonShimmer className="h-4 w-3/4" />
          <SkeletonShimmer className="h-3 w-1/2" />
        </div>
      </div>
      <SkeletonShimmer className="h-20 w-full" />
      <div className="flex gap-2">
        <SkeletonShimmer className="h-8 w-20" />
        <SkeletonShimmer className="h-8 w-20" />
      </div>
    </div>
  );
}

export function QRCardSkeleton() {
  return (
    <div className="surface-elevated rounded-2xl p-4 space-y-4">
      <SkeletonShimmer className="h-32 w-32 mx-auto rounded-lg" />
      <div className="space-y-2">
        <SkeletonShimmer className="h-4 w-full" />
        <SkeletonShimmer className="h-3 w-2/3" />
      </div>
      <div className="flex gap-2">
        <SkeletonShimmer className="h-9 flex-1" />
        <SkeletonShimmer className="h-9 w-9" />
      </div>
    </div>
  );
}

export function TableRowSkeleton() {
  return (
    <div className="flex items-center gap-4 p-4 border-b border-border">
      <SkeletonShimmer className="h-10 w-10 rounded" />
      <SkeletonShimmer className="h-4 flex-1" />
      <SkeletonShimmer className="h-4 w-20" />
      <SkeletonShimmer className="h-8 w-8 rounded" />
    </div>
  );
}
